// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonialContainer {
  margin-top: 64px;
}

@media only screen and (max-width: 767.98px) {
  /* Screens below medium */
  .testimonialContainer {
    margin-top: 50px;
  }
}

.growBusinessHeading {
  font-family: "Roboto";
  font-style: 30px;
  font-weight: 700;
  font-size: 40px;
  line-height: 56px;
  color: #333333;
}

@media only screen and (max-width: 767.98px) {
  .growBusinessHeading {
    color: #333;
    text-align: center;
    font-size: 30px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    line-height: 44px;
    margin-top: -35px;
  }
}

.growBusinessPara {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  color: #333333;
  margin-top: 42px;
}
@media only screen and (max-width: 767.98px) {
  .growBusinessPara {
    color: #333;
    text-align: center;
    font-size: 16px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-top: 15px;
  }
}
.newsLatterBox {
  height: 320px;
  margin-top: 33px;
  background: #5b7cfd;
  border-radius: 8px;
}

@media only screen and (max-width: 767.98px) {
  .newsLatterBox {
    height: 180px;
  }
}

.getInTouchText {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 56px;
  /* or 140% */

  color: #ffffff;
  margin-left: 2rem;
}

@media only screen and (max-width: 767.98px) {
  .getInTouchText {
    font-style: normal;
    font-family: "Roboto";
    font-size: 20px;
    font-weight: 700;
    line-height: 29px;
    letter-spacing: 0px;
    text-align: left;
  }
}

.newsLatterCoustomInput {
  width: 456px; /* Default width for medium-sized screens and above */
  height: 56px;
  background: #ffffff;
  border-radius: 4px;
  border: none;
}

@media (max-width: 767px) {
  /* Apply styles for screens below 768 pixels width */
  .newsLatterCoustomInput {
    width: 99%; /* Set the desired width for screens below 768 pixels width */
    margin-top: 1rem;
  }
}

.newsLatterCoustomInput::placeholder {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #999999;
  /* padding-left: 25px; */
}

.sendNewsLatterButtonBox {
  width: 110px;
  height: 48px;
  background: #5b7cfd;
  border-radius: 4px;
}

@media only screen and (max-width: 767.98px) {
  .testCheck {
    position: relative;
  }
  .sendNewsLatterButtonBox {
    position: absolute;
    right: 2%;
    bottom: 2%;
  }
}

.sendButtonIcon {
  margin-top: 2px;
  margin-left: 25px;
}
.sendNewsLatterButtonText {
  margin-top: 15px;
  margin-right: 15px;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/MudasirScreens/HRManagement/components/NewsLatter/NewsLatter.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;;EAEZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY,EAAE,qDAAqD;EACnE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oDAAoD;EACpD;IACE,UAAU,EAAE,6DAA6D;IACzE,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;;EAElB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".testimonialContainer {\n  margin-top: 64px;\n}\n\n@media only screen and (max-width: 767.98px) {\n  /* Screens below medium */\n  .testimonialContainer {\n    margin-top: 50px;\n  }\n}\n\n.growBusinessHeading {\n  font-family: \"Roboto\";\n  font-style: 30px;\n  font-weight: 700;\n  font-size: 40px;\n  line-height: 56px;\n  color: #333333;\n}\n\n@media only screen and (max-width: 767.98px) {\n  .growBusinessHeading {\n    color: #333;\n    text-align: center;\n    font-size: 30px;\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 700;\n    line-height: 44px;\n    margin-top: -35px;\n  }\n}\n\n.growBusinessPara {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 32px;\n  text-align: center;\n  color: #333333;\n  margin-top: 42px;\n}\n@media only screen and (max-width: 767.98px) {\n  .growBusinessPara {\n    color: #333;\n    text-align: center;\n    font-size: 16px;\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    margin-top: 15px;\n  }\n}\n.newsLatterBox {\n  height: 320px;\n  margin-top: 33px;\n  background: #5b7cfd;\n  border-radius: 8px;\n}\n\n@media only screen and (max-width: 767.98px) {\n  .newsLatterBox {\n    height: 180px;\n  }\n}\n\n.getInTouchText {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 40px;\n  line-height: 56px;\n  /* or 140% */\n\n  color: #ffffff;\n  margin-left: 2rem;\n}\n\n@media only screen and (max-width: 767.98px) {\n  .getInTouchText {\n    font-style: normal;\n    font-family: \"Roboto\";\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 29px;\n    letter-spacing: 0px;\n    text-align: left;\n  }\n}\n\n.newsLatterCoustomInput {\n  width: 456px; /* Default width for medium-sized screens and above */\n  height: 56px;\n  background: #ffffff;\n  border-radius: 4px;\n  border: none;\n}\n\n@media (max-width: 767px) {\n  /* Apply styles for screens below 768 pixels width */\n  .newsLatterCoustomInput {\n    width: 99%; /* Set the desired width for screens below 768 pixels width */\n    margin-top: 1rem;\n  }\n}\n\n.newsLatterCoustomInput::placeholder {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  color: #999999;\n  /* padding-left: 25px; */\n}\n\n.sendNewsLatterButtonBox {\n  width: 110px;\n  height: 48px;\n  background: #5b7cfd;\n  border-radius: 4px;\n}\n\n@media only screen and (max-width: 767.98px) {\n  .testCheck {\n    position: relative;\n  }\n  .sendNewsLatterButtonBox {\n    position: absolute;\n    right: 2%;\n    bottom: 2%;\n  }\n}\n\n.sendButtonIcon {\n  margin-top: 2px;\n  margin-left: 25px;\n}\n.sendNewsLatterButtonText {\n  margin-top: 15px;\n  margin-right: 15px;\n\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
